<template>
  <div class="container mt-4" id="thankyouPayment">
    <div>
      <el-row>
        <el-col :span="24">
          <div class="grid-content">
            <img src="../assets/tick.png" style="width: 100px" />
            <h3 style="font-weight: normal; font-family: Gabriola">Thank you for payment.</h3>
            <p style="margin-bottom: 0px"><small>Please check your email for e-receipt.</small></p>
            <p><small>You will receive an email shortly with PDF to download.</small></p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'thankyouPayment',
  data() {},
}
</script>

<style scoped></style>
